export const sentimentByRating = {
  chart: {
    type: 'bar'
  },
  title: {
    text: ''
  },
  subtitle: {
    text: ''
  },
  xAxis: {
    allowDecimals: false,
    minPadding: 0,
    categories: [],
    style: { fontFamily: '\'Open Sans\', sans-serif' },
    title: {
      text: null
    },
    labels: {
      style: {
        fontFamily: '\'Open Sans\', sans-serif'
      }
    }
  },
  yAxis: {
    allowDecimals: false,
    minPadding: 0,
    categories: [],
    style: { fontFamily: '\'Open Sans\', sans-serif' },
    title: {
      text: ''
    },
    labels: {
      style: {
        fontFamily: '\'Open Sans\', sans-serif'
      }
    }
  },
  tooltip: {},
  plotOptions: {
    bar: {
      dataLabels: {
        enabled: true,
        style: { fontFamily: '\'Open Sans\', sans-serif' }
      }
    },
    series: {
      animation: true,
      stacking: 'normal'
    }
  },
  legend: {
    enabled: false
  },
  credits: {
    enabled: false
  },
  series: []
};
